import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AdminApp } from './AdminApp';

export const queryClient = new QueryClient();
const router = createBrowserRouter([{ path: '*', element: <AdminApp /> }]);

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
